import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { TilesDetails } from 'src/app/core/interfaces/library-v2-data.i';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics-service/google-analytics.service';
import { NgbModal, NgbModalOptions,ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { QrConstants } from 'src/app/core/services/qr-input-service/qr.constants';
import { environment } from 'src/environments/environment';
import { UlthreedmarkService } from 'src/app/modules/details-page/services/ulthreedmark/ulthreedmark.service';
@Component({
  selector: 'app-panther-lake-overview',
  templateUrl: './panther-lake-overview.component.html',
  styleUrls: ['./panther-lake-overview.component.scss']
})
export class PantherLakeOverviewComponent implements OnInit {
  overviewLibraryContent: TilesDetails[];
  splitTile: TilesDetails;
  gridTiles: TilesDetails[];
  ptlVAHomePageText: any;
  ptlHomePageText:string;
  ptlType: string;
  language: string;
  vaSearchSendIcon: any;
  setIntelDisplayOneFont: boolean;
  legalContent: any;
  legalText: string;
  legalVersion: string;
  direction: string;
  legalTextFontClass: string;
  aiShowcaseUrl = environment.aiShowcaseUrl;
	pcMoverUrl = environment.pcMoverUrl;
  showVirtualAssistant: boolean = false;
  singleTileImagePath:string;
  isScrollable: boolean = false;
  nonItalicLangArray = ['ar-sa','he','ja','ko','th','zh-cn','zh-tw'];
  aiPcBundleUrl = environment.aiPcBundleUrl;
  isRTL: boolean = false;
  vaInputValue: string = '';

  constructor(
    private router: Router,
    private libraryService: LibraryV2DataService,
    private qrCodeService: QrCodeService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private modalService: NgbModal,
    private ulthreedmarkService: UlthreedmarkService
  ) { }

  ngOnInit(): void {
    
    this.ptlVAHomePageText = this.libraryService.getStaticText('tr_VAHomepageText'); 
    if(this.qrCodeService?.isPantherLakeStd){
      this.ptlHomePageText = this.libraryService.getStaticText('tr_PTLHomePageText');
      this.ptlType = GlobalConstants.PANTHER_LAKE;
      this.vaSearchSendIcon = this.ptlVAHomePageText?.ptl_VASearchSendIcon;
      this.singleTileImagePath = 'assets/images/ptl_processor_single_tile.png';
    } else if(this.qrCodeService?.isPantherLake12Xe) {
      this.ptlHomePageText = this.libraryService.getStaticText('tr_PTL12XEHomePageText');
      this.ptlType = GlobalConstants.PANTHER_LAKE_12XE;
      this.vaSearchSendIcon = this.ptlVAHomePageText?.ptl12xe_VASearchSendIcon;
      this.singleTileImagePath= 'assets/images/ptl12xe_processor_single_tile.png';
    } else if (this.qrCodeService?.isPantherLakeGaming) {
      this.ptlHomePageText = this.libraryService.getStaticText('tr_PTLGamingHomePageText'); 
      this.ptlType = GlobalConstants.PANTHER_LAKE_GAMING;
      this.vaSearchSendIcon = this.ptlVAHomePageText?.ptl_gaming_VASearchSendIcon;
      this.singleTileImagePath= 'assets/images/ptlgaming_processor_single_tile.png';
    }
    this.overviewLibraryContent = this.libraryService.getTilesData(this.ptlType, GlobalConstants.DEFAULT_TYPE);
    if (!this.isSoftwareBundleTileEnabled()) {
      this.overviewLibraryContent = this.overviewLibraryContent.filter(tile => tile.tileUrlName !== 'ptl-softwarebundle');
	  }
    if(this.ulthreedmarkService.getFpsData().length == 0){
    this.overviewLibraryContent = this.overviewLibraryContent.filter(tile => tile.tileUrlName !== 'ulthreedmark')
    }

    const { isAIShowcaseAvailable, isPcMoverAvailable, isAiDemosAvailable } = this.checkSpecialTilesAvailability();
    this.overviewLibraryContent = this.overviewLibraryContent.filter(tile => {
    if (tile.tileUrlName === 'aishowcase') return isAIShowcaseAvailable;
    if (tile.tileUrlName === 'pcmover') return isPcMoverAvailable;
    if (tile.tileUrlName === 'aidemos') return isAiDemosAvailable;
    if (tile.tileUrlName === GlobalConstants.AI_PC_BUNDLE) return this.qrCodeService.isAiPcBundleAvailable;
    return true;
    });
    

    this.splitTile = this.overviewLibraryContent[0];
    this.gridTiles = this.overviewLibraryContent.slice(1);
    
    const qrData = this.qrCodeService.getQrData();
    this.language = qrData.Language;
    this.legalTextFontClass = this.qrCodeService.setFont();
    this.setIntelDisplayOneFont = this.qrCodeService.setenusLang();
    this.direction = this.qrCodeService.direction;
    this.legalVersion = '&nbsp;' + this.qrCodeService.qrInput?.LegalVersion;
    this.legalContent = this.libraryService.getHeaders('legal').tr_paragraph_array;
    this.legalContent = this.legalContent.map(ele => ele.replace('®', '<sup>®</sup>'));
    this.legalContent = this.legalContent.map(ele => ele.replace('[ZhCn Only Legal Text General]', ''));  // zh-cn legalcontent
    this.legalContent = this.legalContent.map(ele => ele.replace('[ZhCn Only Legal Text Point12]', ''));
    this.legalContent = this.legalContent.map(ele => ele.replace('[ZhCn Only Legal Text Point13]', ''));
    this.legalText = this.libraryService.getHeaders('legal').tr_specTitle;
    this.showVirtualAssistant = this.qrCodeService?.showVirtualAssistant;
    this.isRTL = this.qrCodeService?.qrInput?.Language === "ar-sa" || this.qrCodeService?.qrInput?.Language === "he";
    setTimeout(() => {
      const scrollContainer = document.querySelector('.content') as HTMLElement;
      if (scrollContainer) {
       this.isScrollable = scrollContainer.scrollHeight > scrollContainer.clientHeight;
        }
    }, 0);
    this.qrCodeService.vaUserInput = '';
  }
  
  routeToTab(queryParam : string) {
    if (this.vaInputValue) {
      this.qrCodeService.vaUserInput = this.vaInputValue?.trim();
    }
    this.vaInputValue = '';
    this.router.navigate([], { queryParams: { activeTab: queryParam } });
  }

  routeToTileDetailsPage(tileUrl: string) {
    if (tileUrl === GlobalConstants.AI_SHOWCASE || tileUrl === GlobalConstants.PC_MOVER || tileUrl === GlobalConstants.AI_PC_BUNDLE) {
      const targetUrl = tileUrl === GlobalConstants.AI_SHOWCASE ? this.aiShowcaseUrl : tileUrl === GlobalConstants.PC_MOVER ? this.pcMoverUrl : this.aiPcBundleUrl;
      this.googleAnalyticsService.factTagAnalytics(
        `${tileUrl}_${targetUrl}`,
        GlobalConstants.TILE
      );
      window.open(targetUrl, '_blank');
    } else if (tileUrl === GlobalConstants.PTL_PLAY_LIKE_PROS_LINK) {
      this.googleAnalyticsService.factTagAnalytics(tileUrl, GlobalConstants.TILE); // II-3852
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/specs/influencer']);
      });
    } 
    else {
      this.googleAnalyticsService.factTagAnalytics(tileUrl, GlobalConstants.TILE); // II-3852
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/specs/' + tileUrl]);
      });
    }
  }
  
  private isSoftwareBundleTileEnabled(): boolean {
   const expiryDate = new Date(GlobalConstants.SW_BUNDLE_CUTOFF_END_DATE);
	  return new Date() < expiryDate;
  }

  open(content: any) {
  this.modalService.open(content, {
    backdrop : 'static',
    centered: true,
    windowClass: 'legal-text-popup'
  });
  }

  close() {
    this.modalService.dismissAll();
  }
  
  checkSpecialTilesAvailability() {
    const qrInput = this.qrCodeService?.qrInput;
    const isAIShowcaseAvailable =
      qrInput?.Language === GlobalConstants.EN_US_SMALL &&
      qrInput?.Os !== GlobalConstants.ANA &&
      [GlobalConstants.PANTHER_LAKE,GlobalConstants.PANTHER_LAKE_12XE,GlobalConstants.PANTHER_LAKE_GAMING].includes(this.ptlType);

    const isPcMoverAvailable =
      GlobalConstants.PC_MOVER_AVAILABLE_LANGUAGES?.includes(qrInput?.Language) &&
      new Date() < new Date(GlobalConstants.PC_MOVER_CUTOFF_END_DATE) &&
      [QrConstants.W11, QrConstants.WINDOWS_11_UWP, QrConstants.WINDOWS_11_UWP_S_MODE].includes(qrInput?.Os) &&
      [GlobalConstants.PANTHER_LAKE, GlobalConstants.PANTHER_LAKE_12XE].includes(this.ptlType);

    const isAiDemosAvailable = qrInput?.Language === GlobalConstants.EN_US_SMALL;


    return {
      isAIShowcaseAvailable,
      isPcMoverAvailable,
      isAiDemosAvailable
    };
  }

}
